import React from "react";
import {
  Box,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { TSkill } from "../../utils/about";

const SkillIcon = ({ icon: Icon, name, color }: any) => (
  <Tooltip title={name} arrow placement="top">
    <Box
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "transform 0.2s ease",
        "&:hover": {
          transform: "scale(1.1)",
        },
      }}
    >
      <Icon
        style={{
          fontSize: { xs: "2rem", sm: "2.2rem", md: "2.5rem" },
          color: color,
          width: "22px",
          height: "22px",
        }}
      />
    </Box>
  </Tooltip>
);

type TSkillProps = {
  skills: TSkill[];
};

const Skills: React.FC<TSkillProps> = ({ skills }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const renderMobileLayout = () => {
    const halfLength = Math.ceil(skills.length / 2);
    const firstRow = skills.slice(0, halfLength);
    const secondRow = skills.slice(halfLength);

    return (
      <>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            width: "100%",
            justifyContent: "center",
            mb: 2,
          }}
        >
          {firstRow.map((skill) => (
            <SkillIcon key={skill.name} {...skill} />
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            width: "100%",
            justifyContent: "center",
          }}
        >
          {secondRow.map((skill) => (
            <SkillIcon key={skill.name} {...skill} />
          ))}
        </Box>
      </>
    );
  };

  const renderDesktopLayout = () => (
    <Box
      sx={{
        display: "flex",
        gap: { xs: 2, md: 3 },
        width: "100%",
        justifyContent: "center",
      }}
    >
      {skills.map((skill) => (
        <SkillIcon key={skill.name} {...skill} />
      ))}
    </Box>
  );

  return <Box>{isMobile ? renderMobileLayout() : renderDesktopLayout()}</Box>;
};

export default Skills;
